import React from 'react';

import {FlyToInterpolator} from 'react-map-gl';

import SchoolIcon from '@material-ui/icons/School';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import SportsHandballIcon from '@material-ui/icons/SportsHandball';
import NatureIcon from '@material-ui/icons/Nature';
import DirectionsBusIcon from '@material-ui/icons/DirectionsBus';
import DirectionsBikeIcon from '@material-ui/icons/DirectionsBike';
import DirectionsWalkIcon from '@material-ui/icons/DirectionsWalk';

import Cercanias from './components/icons/Cercanias';

export const INITIAL_VIEWPORT = {
  latitude: 40.41778,
  longitude: -3.70353,
  zoom: 14,
  bearing: 0,
  pitch: 0,
  transitionDuration: 1000,
  transitionInterpolator: new FlyToInterpolator(),
};

export const MAPSTYLES = [
  {
    'label': 'Liberty',
    'thumbnail': 'https://tileserver.geomatico.es/styles/osm-liberty/18/128401/98838.png',
    'url': 'https://tileserver.geomatico.es/styles/osm-liberty/style.json',
    'firstTopLayer': 'water_name_line'
  },
  {
    'label': 'Hibrid',
    'thumbnail': 'https://openicgc.github.io/img/orto.png',
    'url': 'https://geoserveis.icgc.cat/contextmaps/hibrid.json',
    'firstTopLayer': 'place-other'
  },
  {
    'label': 'Basic',
    'thumbnail': 'https://tileserver.geomatico.es/styles/klokantech-basic/7/63/48.png',
    'url': 'https://tileserver.geomatico.es/styles/klokantech-basic/style.json',
    'firstTopLayer': 'poi_label'
  },
  {
    'label': 'Gray',
    'thumbnail': 'https://tileserver.geomatico.es/styles/fiord-gray/7/63/48.png',
    'url': 'https://tileserver.geomatico.es/styles/fiord-gray/style.json',
    'firstTopLayer': 'water_name'
  }
];

export const INITIAL_MAPSTYLE_URL = MAPSTYLES[0].url;

export const MAPSTYLEURL = 'style.json';

const poiIconStyle = {
  color: '#005C7E',
  fontSize: 18,
  filter: 'drop-shadow(2px 2px 1px rgba(0,0,0,.2))'
};

export const MAP_LEGEND = [{
  id: 'educacion',
  name: 'Educación',
  type: 'icon',
  icon: <SchoolIcon style={poiIconStyle}/>
}, {
  id: 'salud',
  name: 'Salud',
  type: 'icon',
  icon: <LocalHospitalIcon style={poiIconStyle}/>
}, {
  id: 'deportes',
  name: 'Deportes',
  type: 'icon',
  icon: <SportsHandballIcon style={poiIconStyle}/>
}, {
  id: 'medioambiente',
  name: 'Medioambiente',
  type: 'icon',
  icon: <NatureIcon style={poiIconStyle}/>
}, {
  id: 'renfe',
  name: 'Cercanías',
  type: 'icon',
  icon: <Cercanias style={poiIconStyle}/>
}, {
  id: 'bus',
  name: 'Bus',
  type: 'icon',
  icon:  <DirectionsBusIcon style={poiIconStyle}/>
}];

export const WIDESCREEN_STEP = '770px';
export const DRAWER_WIDTH = '300px';

export const MODES = [{
  id: 'foot',
  label: 'A Pie',
  icon: <DirectionsWalkIcon/>
}, {
  id: 'cycling',
  label: 'En Bicicleta',
  icon: <DirectionsBikeIcon/>
}];
